<mat-icon class="status-icon" [ngStyle]="{'color': status?.color}">brightness_1</mat-icon>
<span class="name-status">{{ status?.name }}</span>